"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const dump_truck_types_1 = require("./dump-truck.types");
const app_types_1 = require("../../app.types");
const initialState = {
    isLoading: true,
    isError: false,
    isSuccess: false,
    isLoadingSubmit: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    dataContractor: [],
    mutationMode: false,
    dataItem: {
        id: '0',
        contractor_id: '',
        contractor_name: '',
        contractor: {
            id: '',
            contractor_code: '',
            contractor_name: '',
            contractor_type: '',
            is_active: {
                status: 'Active',
                value: true
            },
            modified_by: '',
            modified_date: new Date(),
            created_by: '',
            created_date: new Date(),
        },
        is_active: {
            value: true,
            status: 'Active'
        },
        dumptruck_no: '',
        capacity_volume: 0,
        dumptruck_spec: '',
        modified_by: '',
        created_date: new Date(),
        modified_date: new Date(),
        rfid_tag: ''
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }]
    }
};
const dumpTruckReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [dump_truck_types_1.dumpTruckTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [dump_truck_types_1.dumpTruckTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [dump_truck_types_1.dumpTruckTypes.GET_DETAIL]: (state, action) => {
        const dataContractor = action.payload;
        return Object.assign(Object.assign({}, state), { dataContractor });
    },
    [dump_truck_types_1.dumpTruckTypes.SET_ERROR]: (state, action) => {
        const { errorCode, isError, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isError,
            errorCode,
            errorMessage, isLoading: false, isSuccess: false, isLoadingSubmit: false });
    },
    [dump_truck_types_1.dumpTruckTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess, isLoadingSubmit } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoadingSubmit, mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess });
    },
    [dump_truck_types_1.dumpTruckTypes.ON_DELETE]: (state) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, mutationMode: false });
    },
    [dump_truck_types_1.dumpTruckTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, isLoading: true, mutationMode: false, isLoadingSubmit: isSuccess, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === dataItem.id)
                    return dataItem;
                return item;
            }) });
    },
    [dump_truck_types_1.dumpTruckTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [dump_truck_types_1.dumpTruckTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { sort: action.payload }) });
    }
});
exports.default = dumpTruckReducer;
